import { Navigation } from "swiper/modules";
import { sliders } from "./sliders";

const logosCarousel = document.querySelector(".logosCarousel");
if (logosCarousel) {
  const slides = logosCarousel.querySelectorAll(".swiper-slide");
  const slidesCount = slides.length || 1;
  const slideWidth = 104; // width of each slide in px
  const baseGap = 124; // base spaceBetween in px
  let spaceBetween = baseGap;

  // total width = sum of slide widths + gaps between slides
  const gapsCount = Math.max(0, slidesCount - 1);
  let totalWidth = slidesCount * slideWidth + gapsCount * baseGap;

  if (totalWidth < window.innerWidth && gapsCount > 0) {
    const extra = window.innerWidth - totalWidth;
    const extraPerGap = Math.floor(extra / gapsCount);
    spaceBetween = baseGap + extraPerGap;
  } else if (slidesCount === 1) {
    // if there's only one slide, no gap needed
    spaceBetween = 0;
  }

  const sliderProps = {
    slidesPerView: "auto",
    spaceBetween: spaceBetween,
    loop: true,
    speed: 2500,
    centeredSlides: true,
    autoplay: {
      delay: 1, // use 1ms instead of 0 so autoplay starts immediately
      disableOnInteraction: false, // allow autoplay to resume after interactions
      pauseOnMouseEnter: true, // for Swiper versions that support this option
    },
    freeMode: true,
    grabCursor: false,
    centeredSlides: false,
    watchSlidesVisibility: true,
  };
  sliders(logosCarousel, sliderProps);
}

const heroSlider = document.querySelector(".heroSwiper");

sliders(heroSlider, {
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: false,
  },
  effect: "fade",
  crossFade: true,
  navigation: {
    nextEl: ".swiper-custom-button-next",
    prevEl: ".swiper-custom-button-prev",
  },
});

const offersSwiper = document.querySelector(".offersSwiper");

if (offersSwiper) {
  const slides = offersSwiper.querySelectorAll(".swiper-slide");
  const slidesCount = slides.length || 0;
  
  const swiperConfig = {
    slidesPerView: "auto",
    centeredSlides: true,
    speed: 600,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: false,
    },
    breakpoints: {
      640: {
        slidesPerView: "auto",
        centeredSlides: true,
      },
    },
  };

  // Only add navigation if there's more than one slide
  if (slidesCount > 1) {
    swiperConfig.breakpoints[640].navigation = {
      nextEl: ".swiper-custom-button-next",
      prevEl: ".swiper-custom-button-prev",
    };
  } else {
    // Hide navigation buttons if they exist
    const nextBtn = document.querySelector(".offersSwiper .swiper-custom-button-next");
    const prevBtn = document.querySelector(".offersSwiper .swiper-custom-button-prev");
    if (nextBtn) nextBtn.style.display = "none";
    if (prevBtn) prevBtn.style.display = "none";
  }

  sliders(offersSwiper, swiperConfig);
}

const swiperServices = document.querySelectorAll(".swiperServices");
let swiperInstances = []; // store all created swiper instances

function initSwiperService() {
  if (swiperInstances.length) return; // already initialized
  swiperServices.forEach((service) => {
    const instance = sliders(service, {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: false,
      },
      effect: "fade",
      crossFade: true,
    });
    // sliders(...) may return the Swiper instance; store it if available
    if (instance) {
      swiperInstances.push(instance);
    }
  });
}

function getWindowDetails() {
  const width = window.innerWidth;
  const orientation = width > window.innerHeight ? "landscape" : "portrait";
  return { width, orientation };
}

function handleResize() {
  const { width, orientation } = getWindowDetails();

  if (width < 1023 || orientation === "portrait") {
    if (swiperInstances.length === 0) {
      initSwiperService(); // init only if not already initialized
    }
  } else {
    if (swiperInstances.length > 0) {
      // destroy all stored instances and clear the array
      swiperInstances.forEach((inst) => {
        if (inst && typeof inst.destroy === "function") {
          inst.destroy(true, true);
        }
      });
      swiperInstances = [];
    }
  }
}

handleResize(); // Run on initial load

window.addEventListener("resize", debounce(handleResize, 200));

// Your debounce function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

const threecolsSwiper = document.querySelector(".threecolsSwiper");

threecolsSwiper &&
  sliders(threecolsSwiper, {
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },

    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: false,
    },
  });

// Show the dialog
const newsLetterDialog = document.getElementById("onesalonica-dialog");

function showOneSalonicaDialog() {
  const dialogShown = localStorage.getItem('newsletterDialogShown');
  if (dialogShown === 'true') {
    return; // Don't show dialog if it was already shown
  }

  if (newsLetterDialog && document.body.classList.contains("home")) {
    newsLetterDialog.show();
    // Set flag in localStorage when dialog is shown
    localStorage.setItem('newsletterDialogShown', 'true');
    const form = newsLetterDialog.querySelector("form");
    const email = form.querySelector('input[type="text"]');
    const submitBtn = form.querySelector('button[type="submit"]');
    email.focus();
  }
}

if (newsLetterDialog && document.body.classList.contains("home")) {
  (function () {
    const form = newsLetterDialog.querySelector("form");
    if (!form) return;
    const email = form.querySelector('input[type="text"]');
    const error = form.querySelector(".text-xs.text-clr-red");
    if (!email || !error) return;

    // touched flags to avoid showing validation messages on open
    let emailTouched = false;
    let genderTouched = false;
    let oroiTouched = false;

    // Gender radios
    const genderInputs = form.querySelectorAll('input[name="gender"]');
    let genderError =
      form.querySelector("#gender-error") ||
      form.querySelector(".gender-error");

    if (genderInputs && genderInputs.length) {
      if (!genderError) {
        genderError = document.createElement("div");
        genderError.className = "text-xs text-clr-red gender-error";
        genderError.id = "gender-error";
        genderError.setAttribute("role", "alert");
        genderError.style.display = "none";
        genderError.textContent = "Please select your gender.";
        const lastRadio = genderInputs[genderInputs.length - 1];
        if (lastRadio && lastRadio.parentNode) {
          lastRadio.parentNode.insertBefore(genderError, lastRadio.nextSibling);
        } else {
          form.appendChild(genderError);
        }
      }

      genderInputs.forEach((input) => {
        input.setAttribute("aria-describedby", genderError.id);
        // change: validate only if user has already interacted (touched)
        input.addEventListener("change", () => {
          if (genderTouched) validateGender(true);
          updateSubmitState();
        });
        // mark touched when focus leaves the radio group
        input.addEventListener("blur", () => {
          // if any radio was focused then blurred, mark touched
          genderTouched = true;
          validateGender(true);
          updateSubmitState();
        });
      });
    }

    function validateGender(show = false) {
      if (!genderInputs || genderInputs.length === 0) return true;
      const checked = Array.from(genderInputs).some((i) => i.checked);
      if (!checked) {
        if (show) {
          genderError.style.display = "block";
          // mark all radios as invalid for AT
          genderInputs.forEach((i) => i.setAttribute("aria-invalid", "true"));
        } else {
          genderError.style.display = "none";
          genderInputs.forEach((i) => i.removeAttribute("aria-invalid"));
        }
        return false;
      } else {
        genderError.style.display = "none";
        genderInputs.forEach((i) => i.removeAttribute("aria-invalid"));
        return true;
      }
    }

    // Checkbox "oroi"
    const oroiInput = form.querySelector('input[name="oroi"]');
    let oroiError =
      form.querySelector("#oroi-error") || form.querySelector(".oroi-error");

    if (oroiInput) {
      if (!oroiError) {
        oroiError = document.createElement("div");
        oroiError.className = "text-xs text-clr-red oroi-error";
        oroiError.id = "oroi-error";
        oroiError.setAttribute("role", "alert");
        oroiError.style.display = "none";
        oroiError.textContent = oroiInput.getAttribute("data-error-message") || "You must accept the terms.";
        if (oroiInput.parentNode) {
          oroiInput.parentNode.insertBefore(oroiError, oroiInput.nextSibling);
        } else {
          form.appendChild(oroiError);
        }
      }

      oroiInput.setAttribute("aria-describedby", oroiError.id);
      oroiInput.setAttribute("required", "");
      oroiInput.addEventListener("change", () => {
        if (oroiTouched) validateOroi(true);
        updateSubmitState();
      });
      oroiInput.addEventListener("blur", () => {
        oroiTouched = true;
        validateOroi(true);
        updateSubmitState();
      });
    }

    function validateOroi(show = false) {
      if (!oroiInput) return true;
      if (!oroiInput.checked) {
        if (show) {
          oroiError.style.display = "block";
          oroiInput.setAttribute("aria-invalid", "true");
        } else {
          oroiError.style.display = "none";
          oroiInput.removeAttribute("aria-invalid");
        }
        return false;
      } else {
        oroiError.style.display = "none";
        oroiInput.removeAttribute("aria-invalid");
        return true;
      }
    }

    // Add a comprehensive submit validator (runs before the existing submit handler)
    form.addEventListener("submit", function (e) {
      // mark all controls as touched so errors are shown on submit
      e.preventDefault();
      emailTouched = genderTouched = oroiTouched = true;

      const emailValid = validateEmail(true);
      const genderValid = validateGender(true);
      const oroiValid = validateOroi(true);

      if (!emailValid || !genderValid || !oroiValid) {
        // focus first invalid control
        if (!emailValid) {
          email.focus();
        } else if (!genderValid) {
          const firstRadio = form.querySelector('input[name="gender"]');
          if (firstRadio) firstRadio.focus();
        } else if (!oroiValid) {
          oroiInput.focus();
        }
      } else {
        // all valid, allow submit to proceed
        const genderChecked = form.querySelector('input[name="gender"]:checked');
        const submitObject = {
          Originator: "Popup",
          Email: email.value.trim(),
          Gender: genderChecked ? genderChecked.value : null,
          AcceptTerms: !!(oroiInput && oroiInput.checked),
        };

        submitBtn.classList.add("sending")
        submitBtn.disabled = true;
        // all valid, allow submit to proceed

        const tokenElement = document.getElementsByName(
          "__RequestVerificationToken",
        )[0];
        const token = tokenElement ? tokenElement.value : null;

        const headers = {
          "Content-Type": "application/json; charset=utf-8",
        };
        if (token) {
          headers["RequestVerificationToken"] = token;
        }

        fetch("/umbraco/surface/Newsletter/SubmitNewsletter", {
          method: "POST",
          headers: headers,
          body: JSON.stringify(submitObject),
        })
          .then((response) => {
            submitBtn.classList.remove("sending");
            submitBtn.disabled = false;
            if (!response.ok) {
              throw new Error(response.message || "Something went wrong");
            }
            return response.json();
          })
          .then((result) => {
            const responseEl = document.querySelector("#response-message");
            if (responseEl) {
              if (result.statusCode === 200) {
                // Success message
                responseEl.innerHTML = `
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-green-400">
                                        <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p id="response-message-text" class="text-sm font-medium text-green-800">${result.message}</p>
                                </div>
                            </div>`;
              } else {
                // Error message
                responseEl.innerHTML = `
                            <div class="rounded-md bg-red-50 p-4">
                                <div class="flex">
                                    <div class="shrink-0">
                                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-red-400">
                                            <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <div class="ml-3">
                                        <h3 class="text-sm font-medium text-red-800">${result.message}</h3>
                                    </div>
                                </div>
                            </div>`;
              }
            }
          })
          .catch((error) => {
            submitBtn.classList.remove("sending");
            submitBtn.disabled = false;
            const responseEl = document.querySelector("#response-message");
            if (responseEl) {
              responseEl.innerHTML = `
                        <div class="rounded-md bg-red-50 p-4">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-red-400">
                                        <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <h3 class="text-sm font-medium text-red-800">${error.message}</h3>
                                </div>
                            </div>
                        </div>`;
            }
            console.error("Error:", error);
          });
      }
    });

    // Ensure accessible IDs / attributes
    if (!email.id) email.id = "newsletter-email";
    error.id = error.id || "email-error";
    error.setAttribute("role", "alert");
    error.style.display = "none";
    email.setAttribute("aria-describedby", error.id);
    // manage submit state instead of using `required`
    const submitBtn = form.querySelector(
      'button[type="submit"], input[type="submit"]',
    );
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute("aria-disabled", "true");
    }

    // update submit button enabled state based on all validators
    function updateSubmitState() {
      // run silent validation checks (do not show errors)
      const emailOk = validateEmail(false);
      const genderOk = validateGender(false);
      const oroiOk = validateOroi(false);

      const allOk = emailOk && genderOk && oroiOk;

      if (submitBtn) {
        submitBtn.disabled = !allOk;
        if (!allOk) submitBtn.setAttribute("aria-disabled", "true");
        else submitBtn.removeAttribute("aria-disabled");
      }
      return allOk;
    }

    // ensure interactive controls update the submit button state
    // input: update state silently
    email.addEventListener("input", function () {
      updateSubmitState();
    });
    // blur: mark touched and run visible validation
    email.addEventListener("blur", function () {
      emailTouched = true;
      validateEmail(true);
      updateSubmitState();
    });

    if (genderInputs && genderInputs.length) {
      genderInputs.forEach((i) =>
        i.addEventListener("change", updateSubmitState),
      );
    }
    if (oroiInput) {
      oroiInput.addEventListener("change", updateSubmitState);
    }

    // initial check (silent, so no errors shown on open)
    updateSubmitState();

    // Simple email regex (reasonable balance of correctness and permissiveness)
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showError() {
      email.setAttribute("aria-invalid", "true");
      error.style.display = "block";
    }

    function hideError() {
      email.removeAttribute("aria-invalid");
      error.style.display = "none";
    }

    // validateEmail(show = false) - when show=true, display error; otherwise be silent
    function validateEmail(show = false) {
      const val = (email.value || "").trim();
      const ok = val !== "" && emailRe.test(val);
      if (!ok) {
        if (show || emailTouched) showError();
        else hideError();
        return false;
      }
      hideError();
      return true;
    }

    // Live feedback: keep input listener silent (already handled above). The explicit validate listeners below
    // ensure we do not show errors while the dialog opens; only on blur/show.
    // Prevent duplicate submission handler: ensure final safeguard uses visible validation
    form.addEventListener("submit", function (e) {
      if (!validateEmail(true)) {
        e.preventDefault();
        email.focus();
      }
    });
  })();
}

// Close button handler
// Use document.getElementById or dialog.querySelector (getElementById is not a method on elements)
const closeBtn =
  document.getElementById("onesalonica-close") ||
  (newsLetterDialog && newsLetterDialog.querySelector("#onesalonica-close"));
if (closeBtn && newsLetterDialog) {
  closeBtn.addEventListener("click", function () {
    newsLetterDialog.close();
  });
}

// Close dialog on Escape key when it's open
document.addEventListener("keydown", function (e) {
  if (!newsLetterDialog) return;
  const isOpen =
    typeof newsLetterDialog.open !== "undefined"
      ? newsLetterDialog.open
      : newsLetterDialog.hasAttribute && newsLetterDialog.hasAttribute("open");
  if (!isOpen) return;
  // Use modern properties and avoid deprecated `keyCode`
  const isEscape =
    (e.key && e.key.toLowerCase() === "escape") ||
    e.key === "Esc" ||
    e.code === "Escape";
  if (isEscape) {
    e.preventDefault();
    if (typeof newsLetterDialog.close === "function") newsLetterDialog.close();
  }
});

const dialogContents = document.getElementById("newsletterDialog");

function handleOutsideClick(event) {
  if (newsLetterDialog.open && !dialogContents.contains(event.target)) {
    // Your desired function to run when clicking outside
    newsLetterDialog.close();
  }
}

window.addEventListener("mousedown", handleOutsideClick);

// Optional: Show dialog on page load
window.addEventListener("DOMContentLoaded", function () {
  if (!newsLetterDialog) return;
  let threshold = window.innerHeight * 0.5;
  function onScroll() {
    if (window.scrollY >= threshold) {
      showOneSalonicaDialog();
      window.removeEventListener("scroll", onScroll, { passive: true });
      window.removeEventListener("resize", onResize);
    }
  }
  function onResize() {
    threshold = window.innerHeight * 0.5;
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize);
  // check immediately in case the page was loaded already scrolled past threshold
  onScroll();
});
